import React from 'react';

import SettingsContext from 'src/features/administration/context/SettingsContext';
import { Settings } from 'src/features/administration/utils/types';
import { LOCALE } from 'src/providers/types';

const defaultSettings: Settings = {
    languages: [LOCALE.EN, LOCALE.BG],
    default_language: 'en',
};

function SettingsProvider({ children }: { children: React.ReactNode }) {
    return <SettingsContext.Provider value={defaultSettings}>{children}</SettingsContext.Provider>;
}

export { SettingsProvider };
